import env from './env';

/**
 * Firefox, Edge, Safari and Chrome v58+ will use the standard version
 * of getStats API.
 * https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/getStats#Browser_compatibility
 */
export default () => (
  (env.name === 'Chrome' && env.version >= 58) ||
  (env.name === 'Samsung' && env.version >= 7) ||
  (env.isIosWebView && env.iOSVersion >= 11) ||
  (env.isAndroidWebView && env.androidVersion >= 4.4) ||
  (['Firefox', 'Edge', 'Safari', 'Opera'].indexOf(env.name) !== -1)
);
